<ng-template #score>
    <div class="d-flex flex-row align-self-center">
        <span class="count" [class.dark]="pointsTeamA > pointsTeamB">{{ pointsTeamA }}</span>
        <div class="colon">:</div>
        <span class="count" [class.dark]="pointsTeamA < pointsTeamB">{{ pointsTeamB }}</span>
    </div>
</ng-template>

<div class="l-match">
    @if (first) {
        <div class="match-date">
            {{ 'MATCH_BOX.CURRENTLY_PLAYING' | translate }}
        </div>
    }
    <div class="d-flex align-items-center justify-content-center w-100">
        <div
            class="avatar d-none d-md-flex justify-content-center align-items-center"
            [matTooltip]="
                match?.expectedOutcome?.elo2
                    ? ('MATCHBOX.PREV_ELO'
                      | translate
                          : {
                                elo1: match?.expectedOutcome?.elo1,
                                elo2: match?.expectedOutcome?.elo2,
                                sum: match?.expectedOutcome?.elo1 + match?.expectedOutcome?.elo2,
                            })
                    : ''
            "
        >
            <div>{{ match?.expectedOutcome?.expectedOutcome * 100 | number: '1.0-0' }} %</div>
        </div>
        <div class="line">
            @if (match.settings.gameMode === gameMode.OneAgainstOne) {
                <div class="match-grid align-items-center">
                    <div class="name">
                        {{ match.teamA[0].displayName }}
                    </div>
                    <ng-container *ngTemplateOutlet="score"></ng-container>
                    <div class="name">
                        {{ match.teamB[1].displayName }}
                    </div>
                </div>
            }

            @if (match.settings.gameMode === gameMode.TwoAgainstTwo) {
                <div class="match-grid">
                    <div class="names-grid-1 justify-content-center">
                        <span class="roles">
                            @for (s of match.sets; track s) {
                                <i class="fa-xs fas" [ngClass]="getRoleIcon(s, match.teamA[0])"></i>
                            }
                        </span>
                        <div class="name">
                            {{ match.teamA[0].displayName }}
                        </div>
                        <span class="roles">
                            @for (s of match.sets; track s) {
                                <i class="fa-xs fas" [ngClass]="getRoleIcon(s, match.teamA[1])"></i>
                            }
                        </span>
                        <div class="name">
                            {{ match.teamA[1].displayName }}
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="score"></ng-container>
                    <div class="names-grid-2 justify-content-center">
                        <div class="name">
                            {{ match.teamB[0].displayName }}
                        </div>
                        <span class="roles">
                            @for (s of match.sets; track s) {
                                <i class="fa-xs fas" [ngClass]="getRoleIcon(s, match.teamB[0])"></i>
                            }
                        </span>
                        <div class="name">
                            {{ match.teamB[1].displayName }}
                        </div>
                        <span class="roles">
                            @for (s of match.sets; track s) {
                                <i class="fa-xs fas" [ngClass]="getRoleIcon(s, match.teamB[1])"></i>
                            }
                        </span>
                    </div>
                </div>
            }
        </div>

        <div
            class="avatar d-none d-md-flex justify-content-center align-items-center"
            [matTooltip]="
                match?.expectedOutcome?.elo4
                    ? ('MATCHBOX.PREV_ELO'
                      | translate
                          : {
                                elo1: match?.expectedOutcome?.elo3,
                                elo2: match?.expectedOutcome?.elo4,
                                sum: match?.expectedOutcome?.elo3 + match?.expectedOutcome?.elo4,
                            })
                    : ''
            "
        >
            <div>{{ (1 - match?.expectedOutcome?.expectedOutcome) * 100 | number: '1.0-0' }} %</div>
        </div>
    </div>
    <div class="l-score">
        @for (ma of match.sets; track ma; let setIx = $index) {
            <div class="score clickable" [class.selected]="setIx === selectedSet" (click)="selectedSet = setIx">
                <div class="score_numbers">
                    <span class="count score" [class.dark]="ma.teamA.score > ma.teamB.score">{{ ma.teamA.score }}</span>
                    <div class="colonSmall">:</div>
                    <span class="count score" [class.dark]="ma.teamA.score < ma.teamB.score">{{ ma.teamB.score }}</span>
                </div>
            </div>
        }
    </div>

    @if (selectedSet >= 0 && match.sets[selectedSet]?.goals.length) {
        <h4 class="my-3">
            {{ 'DASHBOARD.MATCHBOX_SET_SET' | translate: { set: selectedSet + 1 } }}
        </h4>
    }
    <app-ongoing-match-box-goals
        style="width: 100%; max-width: 600px"
        [match]="match"
        [selectedSet]="selectedSet"
    ></app-ongoing-match-box-goals>
</div>
